import { Component, OnInit } from '@angular/core';
import { DateModel, DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { FormButton } from '@app/core/components/form-field-button/form-field-button.component';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridButton, GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';
import { RememberService } from '@app/core/services/remember.service';
import { StateService } from '@app/core/services/state.service';
import { LogisticService, StockplaceItem } from '@app/services/logistic.service';
@Component({
    selector: 'tt-dispatch-planning',
    templateUrl: './dispatch-planning.component.html',
    styleUrls: ['./dispatch-planning.component.css'],
})
export class DispatchPlanningComponent implements OnInit {
    public get?: DispatchplanningGet;

    public deliverymethods: Item[] = [];

    public stockplaces: StockplaceItem[] = [];

    public grid?: GridOptions;

    public deliveredGrid?: GridOptions;

    public orderInternalNoButtons: FormButton[] = [{ id: 'search', icon: 'fas fa-search', onClick: () => this.readDeliveredGrid(), type: 'primary' }];

    constructor(
        private datatask: DataTaskService,
        private logistic: LogisticService,
        private remember: RememberService,
        private state: StateService,
    ) {}

    public readPlanningGrid() {
        this.grid?.gridfunc?.read?.();
    }

    public readDeliveredGrid() {
        this.deliveredGrid?.gridfunc?.read?.();
    }

    private async loadDeliveryMethods() {
        this.deliverymethods = await this.datatask.Post(1557);
    }

    private async loadStockplaces() {
        this.stockplaces = await this.logistic.getStockplaces({ add_all: '0' });
    }

    private async loadPageGet() {
        this.get = (await this.datatask.Post(1562))[0];
        console.log('this.get :>> ', this.get);
        this.grid = new Grid()
            .setRememberId('dispatchplanning.grid.state')
            .setLoadDataFunction({ method: 3512, parameters: () => this.get! })
            .setConfig({ readAfterPrint: this.get?.refresh_after_print === '1' })
            .setSpecialFunc({ buttons: [{ name: 'create_consignment', icon: 'fas fa-plus', func: this.createConsignment, cssClass: 'tt-button tt-button--primary' }] });

        this.deliveredGrid = new Grid()
            .setRememberId('dispatchplanning.grid.delivered.state')
            .setLoadDataFunction({ method: 3522, parameters: () => this.get! })
            .setConfig({ readAfterPrint: this.get?.refresh_after_print === '1' });
    }

    private createConsignment = async (row: GridRow, button?: GridButton, event?: MouseEvent) => {
        const result = (await this.datatask.Post(3648, { ...row }))[0];

        if ('webpagename' in result && !!result.webpagename && typeof result.webpagename === 'string' && 'parms' in result && typeof result.parms === 'string') {
            this.state.go(result.webpagename, result.parms);
        }
    };

    ngOnInit(): void {
        this.loadPageGet();
        this.loadStockplaces();
        this.loadDeliveryMethods();
    }
}

interface DispatchplanningGet {
    deliverymethod_no: string;
    stockplace_id: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    filter: string;
    tab: string;
    order_order_no: string;
    refresh_after_print: '1' | '0';
}
